import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./PlaceBid.css";
import Header from "../../components/Navbar";
import Footer from "../../components/footer/footer";
import profill from "../../myimgs/Layer_1 (21).png";
import Timers from "../../myimgs/timersd.png";
import BAD from "../../myimgs/bads.png";
import BATH from "../../myimgs/bath.png";
import Uloads from "../../myimgs/uplodsk.png";

const PlaceBid = () => {
  const [propertyData, setPropertyData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [showBidSection, setShowBidSection] = useState(false);
  const [selectedProfiles, setSelectedProfiles] = useState([]);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const [terms1Checked, setTerms1Checked] = useState(false);
  const [terms2Checked, setTerms2Checked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fileInputRef = useRef(null);

  const handleProfileSelect = (id) => {
    setSelectedProfiles((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((profileId) => profileId !== id)
        : [...prevSelected, id]
    );
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type === "application/pdf") {
      setFileName(selectedFile.name);
      setFile(selectedFile);
    } else {
      alert("Only PDF files are allowed.");
      event.target.value = null;
      setFileName("");
      setFile(null);
    }
  };

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const userId = localStorage.getItem("userId");

  const queryParams = new URLSearchParams(window.location.search);
  const propertyId = queryParams.get("id");
  const propeId = queryParams.get("propeId");

  const fetchUserDetails = async () => {
  if (!userId) return;

  try {
    const response = await axios.get(
      `${baseUrl}/user/edit/${userId}`
    );

    console.log("User API Response:", response.data);

    if (response.data?.status === 200) {
      setUserData(response.data.data);
    } else {
      setError("Failed to fetch user details");
    }
  } catch (err) {
    console.error(err);
    setError("Error fetching user details");
  }
};


  useEffect(() => {
  const fetchPropertyDetails = async () => {
    if (!propertyId) {
      setError("Property ID not found in URL.");
      setLoading(false);
      return;
    }

    try {
      let response;

      if (propeId && propeId !== "null") {
        response = await axios.get(
          `${baseUrl}/property/${propertyId}/user-id/${userId}`
        );
      } else {
        response = await axios.get(
          `${baseUrl}/property/realtor-id/${propertyId}/user-id/${userId}`
        );
      }

      if (response.data.status === 200) {
        setPropertyData(response.data.data);
      } else {
        setError("Failed to fetch property details");
      }
    } catch (err) {
      setError("Error fetching property data");
    } finally {
      setLoading(false);
    }
  };

  fetchPropertyDetails();
  fetchUserDetails(); // ✅ NEW USER API CALL
}, [propertyId, userId, baseUrl]);


 const handlePayNow = async () => {
  if (!terms1Checked || !terms2Checked) {
    alert("Please agree to all terms and conditions before proceeding.");
    return;
  }

  if (!file) {
    alert("Please upload a proof of funds PDF.");
    return;
  }

  setIsSubmitting(true);

  const formData = new FormData();
  formData.append("amount", propertyData?.depositAmount || 0);
  formData.append("userId", userId);
  formData.append("purchaesProfile", selectedProfiles.join(","));
  formData.append("doc", file);
  formData.append("isWeb", "true");

  // Conditional append logic
  if (!propeId || propeId === "null") {
    // If propeId is null → send listingId
    formData.append("listingId", propertyData?.listingId || "");
  } else {
    // Otherwise → send propertyId
    formData.append("propertyId", propertyId);
  }

  try {
    const response = await axios.post(
      `${baseUrl}/paypal/create-order`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log("✅ PayPal Order Created:", response.data);

    if (response.data?.orderId) {
      localStorage.setItem("paypalOrderId", response.data.orderId);
    }

    if (response.data?.approvalUrl) {
      window.open(response.data.approvalUrl, "_blank");
    }

    if (response.data?.status === 200 || response.data?.success === true) {
      import("sweetalert2").then(({ default: Swal }) => {
        Swal.fire({
          title: "Now you are eligible to Request & Offer",
          text: "Click OK to continue to property details.",
          icon: "success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = `/propertyDetail?id=${propertyId}&propeId=${propeId}`;
          }
        });
      });
    }
  } catch (error) {
    console.error("PayPal Order Failed:", error);
    alert("Payment initialization failed. Try again.");
  } finally {
    setIsSubmitting(false);
  }
};

  if (error) return <p className="text-danger text-center mt-5">{error}</p>;

  if (loading) return <p className="text-center mt-5">Loading...</p>;

  return (
    <>
      <Header />
      <div className="container my-5 scrolleffect kjkl">
        <div className="row">
          {/* Image Section */}
          <div className="col-md-4">
            <img
              src={
                propertyData?.propertyImages?.[0]?.imageUrl ||
                "/path/to/your/image.jpg"
              }
              alt="Property"
              className="img-fluid rounded"
            />
          </div>

          {/* Property Info Section */}
          <div className="col-md-4">
            <h1 className="mb-3">{propertyData?.propertysubtype}</h1>
            <div className="propnflx">
              {propertyData.propertySubType || "No Name"}
              <div className="property-specs" style={{marginTop:"8px"}}>
                {propertyData.bedroomsTotal > 0 && (
                  <span className="spec">🛏{propertyData.bedroomsTotal}bed</span>
                )}

                {propertyData.bathroomsTotalInteger > 0 && (
                  <span className="spec">
                    🛁{propertyData.bathroomsTotalInteger}bath
                  </span>
                )}

                {propertyData.lotSizeArea > 0 && (
                  <span className="spec">📐{propertyData.lotSizeArea}ft</span>
                )}
              </div>
            </div>

            <p className="h5 lkovb">
              Deposit Amount <br />
              <span className="text-primary">
                {(() => {
                  const details = propertyData.biddingDetails;

                  // CASE 1: If biddingDetails exists
                  if (details) {
                    // If bid has ended → show listPrice
                    if (
                      details.isBidEnd !== null &&
                      details.isBidEnd === true
                    ) {
                      return `$${Number(
                        propertyData.listPrice
                      ).toLocaleString()}`;
                    }

                    // If bid NOT ended → show currentAuctionAmount OR offerStartingPrice
                    return `$${Number(
                      details.currenntAuctionAmount ??
                        details.offerStartingPrice
                    ).toLocaleString()}`;
                  }

                  // CASE 2: If biddingDetails does NOT exist → show listPrice
                  return `$${Number(propertyData.listPrice).toLocaleString()}`;
                })()}
              </span>
            </p>
          </div>

          {/* Timer Section */}
          <div className="col-md-4"></div>
        </div>

        {/* User Profile Form or Bid Section */}
        <div className="row profli">
          <div className="col-md-12">
            <div className="mt-4">
              {!showBidSection ? (
                <form className="kkkjjk">
                  <h2>
                    <img src={profill} alt="" /> Profile Information
                  </h2>

                  <div className="form-row">
                    <div className="col-md-6">
                      <label className="form-label">Full Name</label>
                      <input
                        type="text"
                        className="form-control my-2"
                        value={userData?.name || ""}
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control my-2"
                        value={userData?.email || ""}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="col-md-6">
                      <label className="form-label">Address</label>
                      <input
                        type="text"
                        className="form-control my-2"
                        value={userData?.address || ""}
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">City</label>
                      <input
                        type="text"
                        className="form-control my-2"
                        value={userData?.city || ""}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="col-md-6">
                      <label className="form-label">State</label>
                      <input
                        type="text"
                        className="form-control my-2"
                        value={userData?.state || ""}
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Pincode</label>
                      <input
                        type="text"
                        className="form-control my-2"
                        value={userData?.pincode || ""}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="col-md-6">
                      <label className="form-label">Phone</label>
                      <input
                        type="text"
                        className="form-control my-2"
                        value={userData?.phone || ""}
                        readOnly
                      />
                    </div>
                  </div>

                  <button
                    type="button"
                    className="btn btn-secondary my-3"
                    onClick={() => setShowBidSection(true)}
                  >
                    CONTINUE
                  </button>
                </form>
              ) : (
                <div className="bid-confirmation-section">
                  <h2>Place and confirm a Offer on a property</h2>
                  <h6>Place Your Offer</h6>
                  <h4 className="yorbu">Deposit Amount</h4>
                  <input
                    type="text"
                    className="form-control bid-input"
                    value={`$${propertyData?.depositAmount || 0}`}
                    readOnly
                  />

                  <div className="purchase-profile mt-5">
                    <h5>Purchase Profile</h5>
                    <p>
                      Please select a purchase profile below or create a new
                      one.
                    </p>
                    <div className="d-flex flex-wrap gap-3 profile-cards">
                      {/* <div className="profile-card add-profile">
                        <span>＋</span>
                        <p>Add New Profile</p>
                      </div> */}
                      {propertyData?.purchaseProfile &&
                      propertyData.purchaseProfile.length > 0 ? (
                        propertyData.purchaseProfile.map((profile) => (
                          <div
                            key={profile.id}
                            className="profile-card active-profile"
                          >
                            <div className="rdiod">
                              <input
                                type="checkbox"
                                id={`profile-${profile.id}`}
                                value={profile.id}
                                checked={selectedProfiles.includes(profile.id)}
                                onChange={() => handleProfileSelect(profile.id)}
                              />
                            </div>
                            <label
                              htmlFor={`profile-${profile.id}`}
                              className="profile-label"
                            >
                              <p className="profile-icon">👤</p>
                              <div className="profile-details">
                                <p className="fw-bold mb-1">
                                  {profile.profileName}
                                </p>
                                <p className="mb-0">{profile.name}</p>
                                <p className="text-muted small">
                                  {profile.email}
                                </p>
                              </div>
                            </label>
                          </div>
                        ))
                      ) : (
                        <p>No purchase profiles found.</p>
                      )}
                    </div>
                  </div>

                  <div className="buyer-info mt-2">
                    <h5>Buyer Information</h5>
                    <p>
                      Information has been pre-filled with the selected purchase
                      profile.
                    </p>
                  </div>

                  <div className="proof-section">
                    <h5>Proof of Funds / Pre-Approval Letter</h5>
                    <p>
                      To provide the seller with necessary information, please
                      upload a PDF document.
                    </p>
                    <div>
                      <div className="upload-boxlk" onClick={handleUploadClick}>
                        <img src={Uloads} alt="" /> Upload Proof of Funds
                      </div>
                      {fileName && (
                        <p className="file-name">Uploaded: {fileName}</p>
                      )}
                      <input
                        type="file"
                        accept="application/pdf"
                        style={{ display: "none" }}
                        ref={fileInputRef}
                        onChange={handleFileChange}
                      />
                    </div>
                  </div>

                  <div className="terms mt-2">
                    <input
                      type="checkbox"
                      id="terms1"
                      checked={terms1Checked}
                      onChange={(e) => setTerms1Checked(e.target.checked)}
                    />
                    <label htmlFor="terms1">
                      I agree to terms & conditions.
                    </label>
                    <br />
                    <div className="dfvkj">
                      <input
                        type="checkbox"
                        id="terms2"
                        checked={terms2Checked}
                        onChange={(e) => setTerms2Checked(e.target.checked)}
                      />
                      <label htmlFor="terms2">
                        I hereby acknowledge that the information provided in
                        this contact Information form is complete and accurate.
                      </label>
                    </div>
                  </div>

                  <button
                    className="btn btn-primary mt-3"
                    onClick={handlePayNow}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Processing..." : "Submit"}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PlaceBid;
